import { apiClient, apiClientCentral } from '@/plugins/axios'; // Import your axios instance

const login = async (credentials: { email: string; password: string }) => {
  return await apiClientCentral.post('/user/login', credentials); // Make sure the login endpoint is correct
};

const logout = async () => {
  return await apiClient.post('/user/logout');
};

const getAuthenticatedUser = async () => {
  return await apiClientCentral.get('/user/current'); 
};

const recoverPassword = async (credentials: { email: string; }) => {
  return await apiClientCentral.post('/user/recoverPassword', credentials); 
};

export default {
  login,
  logout,
  getAuthenticatedUser,
  recoverPassword
};
